/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as cameraV1 from "./keyapis_vc_camera_v1.pb"

/**
 * Сервис управления коллекциями камер
 */

/**
 * Сервис управления коллекциями камер
 */
export class CameraCollectionServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения коллекции камер.
   * Для owner, employee возвращаются только коллекции камер c COMPANY_ID из токена.
   * Метод доступен для: admin, service, bti, owner, employee
   */
  GetCameraCollection = (req: GetCameraCollectionRequestDto, init?: RequestInit): Promise<GetCameraCollectionResponseDto> => {
    return fm.request<GetCameraCollectionRequestDto, GetCameraCollectionResponseDto>(`${this.host}/vc/api/v1/camera_collection/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка коллекций камер.
   * Для owner, employee возвращаются только коллекции камер c COMPANY_ID из токена.
   * Метод доступен для: admin, service, bti, owner, employee
   */
  GetCameraCollectionList = (req?: GetCameraCollectionListRequestDto, init?: RequestInit): Promise<GetCameraCollectionListResponseDto[]> => {
    return fm.list<GetCameraCollectionListRequestDto, GetCameraCollectionListResponseDto>(`${this.host}/vc/api/v1/camera_collection/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества коллекций камер.
   * Для owner, employee возвращаются только коллекции камер c COMPANY_ID из токена.
   * Метод доступен для: admin, service, bti, owner, employee
   */
  GetCameraCollectionCount = (req?: GetCameraCollectionCountRequestDto, init?: RequestInit): Promise<GetCameraCollectionCountResponseDto> => {
    return fm.request<GetCameraCollectionCountRequestDto, GetCameraCollectionCountResponseDto>(`${this.host}/vc/api/v1/camera_collection/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод создания и изменения коллекции камер.
   * При изменении коллекции массив external_camera_ids заменяется полностью.
   * Для owner, employee сравнивается COMPANY_ID из токена и company_id коллекции, при несовпадении ошибка доступа.
   * Метод доступен для: admin, service, bti, owner, employee
   */
  SaveCameraCollection = (req: SaveCameraCollectionRequestDto, init?: RequestInit): Promise<SaveCameraCollectionResponseDto> => {
    return fm.request<SaveCameraCollectionRequestDto, SaveCameraCollectionResponseDto>(`${this.host}/vc/api/v1/camera_collection`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления коллекции камер.
   * Проставляет в поле deleted_at текущую дату.
   * Для owner, employee сравнивается COMPANY_ID из токена и company_id коллекции, при несовпадении ошибка доступа.
   * Метод доступен для: admin, service, bti, owner, employee
   */
  DeleteCameraCollection = (req: DeleteCameraCollectionRequestDto, init?: RequestInit): Promise<DeleteCameraCollectionResponseDto> => {
    return fm.request<DeleteCameraCollectionRequestDto, DeleteCameraCollectionResponseDto>(`${this.host}/vc/api/v1/camera_collection/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод восстановления удаленной коллекции камер.
   * Проставляет null в поле deleted_at.
   * Для owner, employee сравнивается COMPANY_ID из токена и company_id коллекции, при несовпадении ошибка доступа.
   * Метод доступен для: admin, service, bti, owner, employee
   */
  PostCameraCollectionRestore = (req: PostCameraCollectionRestoreRequestDto, init?: RequestInit): Promise<PostCameraCollectionRestoreResponseDto> => {
    return fm.request<PostCameraCollectionRestoreRequestDto, PostCameraCollectionRestoreResponseDto>(`${this.host}/vc/api/v1/camera_collection/restore/${encodeURIComponent(req.id)}`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов направлений сортировки.
 * Тип: byte
 */
export enum CameraCollectionPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 * Тип: byte
 */
export type CameraCollectionPagingDirectionTypeResponseEnum = keyof typeof CameraCollectionPagingDirectionType
/**
 * Справочник типов направлений сортировки.
 * Тип: byte
 */
export type CameraCollectionPagingDirectionTypeRequestEnum = Exclude<CameraCollectionPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 * Тип: byte
 */
export enum CameraCollectionPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  ID = "ID",
  /**
   * По имени
   */
  NAME = "NAME",
  /**
   * По времени изменения
   */
  CHANGED_AT = "CHANGED_AT",
}
/**
 * Справочник типов значений сортировки.
 * Тип: byte
 */
export type CameraCollectionPagingOrderByTypeResponseEnum = keyof typeof CameraCollectionPagingOrderByType
/**
 * Справочник типов значений сортировки.
 * Тип: byte
 */
export type CameraCollectionPagingOrderByTypeRequestEnum = Exclude<CameraCollectionPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Коллекция камер
 */
export type CameraCollectionRequestDto = {
  /**
   * Идентификатор коллекции камер.
   * Тип: Guid
   */
  id?: string
  /**
   * Наименование.
   * Диапазон: 3..256
   */
  name: string
  /**
   * Дата изменения коллекции камер.
   * Поле используется при редактировании и создании для контроля актуальности изменяемой версии
   */
  changedAt: string
  /**
   * Идентификатор компании
   */
  companyId: string
  /**
   * Описание.
   * Диапазон: 0..256
   */
  description?: string
  /**
   * Теги коллекции.
   * Диапазон: 0..10
   */
  tags?: string[]
  /**
   * Привязанные к коллекции камеры
   */
  externalCameraIds?: string[]
}
/**
 * Коллекция камер
 */
export type CameraCollectionResponseDto = {
  /**
   * Идентификатор коллекции камер.
   * Тип: Guid
   */
  id: string
  /**
   * Наименование.
   * Диапазон: 3..256
   */
  name: string
  /**
   * Дата изменения коллекции камер.
   * Поле используется при редактировании и создании для контроля актуальности изменяемой версии
   */
  changedAt: string
  /**
   * Идентификатор компании
   */
  companyId: string
  /**
   * Дата удаления коллекции камер.
   * Поле изменяется через методы Delete и Restore
   */
  readonly deletedAt: string | null
  /**
   * Описание.
   * Диапазон: 0..256
   */
  description: string
  /**
   * Теги коллекции.
   * Диапазон: 0..10
   */
  tags: string[]
  /**
   * Привязанные к коллекции камеры
   */
  externalCameraIds: string[]
}
/**
 * Ошибка сохранения
 */
export type CameraCollectionSavingErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: CameraCollectionSavingErrorConflictRequestDto
  /**
   * Попытка сохранить коллекцию камер с company_id не своей компании
   */
  readonly wrongCompanyId: CameraCollectionSavingErrorWrongCompanyIdRequestDto
}>
/**
 * Ошибка сохранения
 */
export type CameraCollectionSavingErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: CameraCollectionSavingErrorConflictResponseDto
  /**
   * Попытка сохранить коллекцию камер с company_id не своей компании
   */
  readonly wrongCompanyId: CameraCollectionSavingErrorWrongCompanyIdResponseDto
}>
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at отличаются
 */
export type CameraCollectionSavingErrorConflictRequestDto = {
}
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at отличаются
 */
export type CameraCollectionSavingErrorConflictResponseDto = {
}
/**
 * Попытка сохранить коллекцию камер с company_id не своей компании.
 * Для ролей owner, employee сохранение разрешено только с company_id своей компании
 */
export type CameraCollectionSavingErrorWrongCompanyIdRequestDto = {
}
/**
 * Попытка сохранить коллекцию камер с company_id не своей компании.
 * Для ролей owner, employee сохранение разрешено только с company_id своей компании
 */
export type CameraCollectionSavingErrorWrongCompanyIdResponseDto = {
}
/**
 * Фильтр коллекций камер
 */
export type CameraCollectionFilterRequestDto = {
  /**
   * По тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Наименование.
   * # - Описание.
   * # - Теги коллекции
   */
  text?: string
  /**
   * По тегам.
   * Диапазон: 0..10
   */
  tags?: string[]
  /**
   * По компаниям.
   * Диапазон: 0..10
   */
  companyIds?: string[]
  /**
   * Показывать удаленные.
   * Если поле не передано, по умолчанию false, фильтр исключает удаленные
   */
  isDeleted?: boolean | null
}
/**
 * Фильтр коллекций камер
 */
export type CameraCollectionFilterResponseDto = {
  /**
   * По тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Наименование.
   * # - Описание.
   * # - Теги коллекции
   */
  text: string
  /**
   * По тегам.
   * Диапазон: 0..10
   */
  tags: string[]
  /**
   * По компаниям.
   * Диапазон: 0..10
   */
  companyIds: string[]
  /**
   * Показывать удаленные.
   * Если поле не передано, по умолчанию false, фильтр исключает удаленные
   */
  isDeleted: boolean | null
}
/**
 * Постраничный вывод
 */
export type CameraCollectionPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * По умолчанию: CHANGED_AT
   */
  orderByType?: CameraCollectionPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType?: CameraCollectionPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * Диапазон: 0..100.
   * По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type CameraCollectionPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * По умолчанию: CHANGED_AT
   */
  orderByType: CameraCollectionPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType: CameraCollectionPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * Диапазон: 0..100.
   * По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Запрос удаления коллекции камер
 */
export type DeleteCameraCollectionRequestDto = {
  /**
   * Идентификатор коллекции камер.
   * Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос удаления коллекции камер
 */
export type DeleteCameraCollectionResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: DeleteCameraCollectionResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type DeleteCameraCollectionResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: cameraV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type DeleteCameraCollectionResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: cameraV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения количества коллекций камер
 */
export type GetCameraCollectionCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: CameraCollectionFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества коллекций камер
 */
export type GetCameraCollectionCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetCameraCollectionCountResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type GetCameraCollectionCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: cameraV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type GetCameraCollectionCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: cameraV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения списка коллекций камер
 */
export type GetCameraCollectionListRequestDto = {
  /**
   * Фильтр
   */
  filter?: CameraCollectionFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Постраничный вывод
   */
  readonly paging: CameraCollectionPagingRequestDto
}>
/**
 * Ответ на запрос получения списка коллекций камер
 */
export type GetCameraCollectionListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Коллекция камер
   */
  readonly data: CameraCollectionResponseDto
  /**
   * Ошибка
   */
  readonly error: GetCameraCollectionListResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type GetCameraCollectionListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: cameraV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type GetCameraCollectionListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: cameraV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения коллекции камер
 */
export type GetCameraCollectionRequestDto = {
  /**
   * Идентификатор коллекции камер.
   * Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос получения коллекции камер
 */
export type GetCameraCollectionResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Коллекция камер
   */
  readonly data: CameraCollectionResponseDto
  /**
   * Ошибка
   */
  readonly error: GetCameraCollectionResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type GetCameraCollectionResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: cameraV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type GetCameraCollectionResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: cameraV1.ValidationErrorResponseDto
}>
/**
 * Запрос восстановления удаленной коллекции камер
 */
export type PostCameraCollectionRestoreRequestDto = {
  /**
   * Идентификатор коллекции камер.
   * Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос восстановления удаленной коллекции камер
 */
export type PostCameraCollectionRestoreResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PostCameraCollectionRestoreResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type PostCameraCollectionRestoreResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: cameraV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type PostCameraCollectionRestoreResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: cameraV1.ValidationErrorResponseDto
}>
/**
 * Запрос на создание коллекции камер
 */
export type SaveCameraCollectionRequestDto = {
  /**
   * Коллекция камер
   */
  data: CameraCollectionRequestDto
}
/**
 * Ответ на запрос на создание коллекции камер
 */
export type SaveCameraCollectionResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Коллекция камер
   */
  readonly data: CameraCollectionResponseDto
  /**
   * Ошибка
   */
  readonly error: SaveCameraCollectionResponseErrorDto
}>
/**
 * Ошибка запроса создания
 */
export type SaveCameraCollectionResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: cameraV1.ValidationErrorRequestDto
  /**
   * Ошибка сохранения
   */
  readonly saving: CameraCollectionSavingErrorRequestDto
}>
/**
 * Ошибка запроса создания
 */
export type SaveCameraCollectionResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: cameraV1.ValidationErrorResponseDto
  /**
   * Ошибка сохранения
   */
  readonly saving: CameraCollectionSavingErrorResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Коллекция камер
   */
  "CameraCollection": {
    "kind": "class",
    "text": "Коллекция камер",
    "fields": {
      /**
       * Идентификатор коллекции камер.
       * Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор коллекции камер.\nТип: Guid",
      },
      /**
       * Наименование.
       * Диапазон: 3..256
       */
      "name": {
        "type": "string",
        "text": "Наименование.\nДиапазон: 3..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дата изменения коллекции камер.
       * Поле используется при редактировании и создании для контроля актуальности изменяемой версии
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата изменения коллекции камер.\nПоле используется при редактировании и создании для контроля актуальности изменяемой версии",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор компании
       */
      "companyId": {
        "type": "int64",
        "text": "Идентификатор компании",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дата удаления коллекции камер.
       * Поле изменяется через методы Delete и Restore
       */
      "deletedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата удаления коллекции камер.\nПоле изменяется через методы Delete и Restore",
      },
      /**
       * Описание.
       * Диапазон: 0..256
       */
      "description": {
        "type": "string",
        "text": "Описание.\nДиапазон: 0..256",
      },
      /**
       * Теги коллекции.
       * Диапазон: 0..10
       */
      "tags": {
        "type": "string",
        "text": "Теги коллекции.\nДиапазон: 0..10",
      },
      /**
       * Привязанные к коллекции камеры
       */
      "externalCameraIds": {
        "type": "string",
        "text": "Привязанные к коллекции камеры",
      },
    },
  },
  /**
   * Ошибка сохранения
   */
  "CameraCollection.SavingError": {
    "kind": "class",
    "text": "Ошибка сохранения",
    "fields": {
      /**
       * Конфликт версий
       */
      "conflict": {
        "type": "CameraCollection.SavingError.Conflict",
        "text": "Конфликт версий",
      },
      /**
       * Попытка сохранить коллекцию камер с company_id не своей компании
       */
      "wrongCompanyId": {
        "type": "CameraCollection.SavingError.WrongCompanyId",
        "text": "Попытка сохранить коллекцию камер с company_id не своей компании",
      },
    },
  },
  /**
   * Конфликт версий.
   * Причины:
   * - В базе хранится другая версия строки, значения changed_at отличаются
   */
  "CameraCollection.SavingError.Conflict": {
    "kind": "class",
    "text": "Конфликт версий.\nПричины:\n- В базе хранится другая версия строки, значения changed_at отличаются",
  },
  /**
   * Попытка сохранить коллекцию камер с company_id не своей компании.
   * Для ролей owner, employee сохранение разрешено только с company_id своей компании
   */
  "CameraCollection.SavingError.WrongCompanyId": {
    "kind": "class",
    "text": "Попытка сохранить коллекцию камер с company_id не своей компании.\nДля ролей owner, employee сохранение разрешено только с company_id своей компании",
  },
  /**
   * Фильтр коллекций камер
   */
  "CameraCollectionFilter": {
    "kind": "class",
    "text": "Фильтр коллекций камер",
    "fields": {
      /**
       * По тексту.
       * Если значение не передано то поиск по нему не производится.
       * # Диапазон: 3..64.
       * # Поиск производится по полям:
       * # - Наименование.
       * # - Описание.
       * # - Теги коллекции
       */
      "text": {
        "type": "string",
        "text": "По тексту.\nЕсли значение не передано то поиск по нему не производится.\n# Диапазон: 3..64.\n# Поиск производится по полям:\n# - Наименование.\n# - Описание.\n# - Теги коллекции",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * По тегам.
       * Диапазон: 0..10
       */
      "tags": {
        "type": "string",
        "text": "По тегам.\nДиапазон: 0..10",
      },
      /**
       * По компаниям.
       * Диапазон: 0..10
       */
      "companyIds": {
        "type": "int64",
        "text": "По компаниям.\nДиапазон: 0..10",
      },
      /**
       * Показывать удаленные.
       * Если поле не передано, по умолчанию false, фильтр исключает удаленные
       */
      "isDeleted": {
        "type": "google.protobuf.BoolValue",
        "text": "Показывать удаленные.\nЕсли поле не передано, по умолчанию false, фильтр исключает удаленные",
      },
    },
  },
  /**
   * Постраничный вывод
   */
  "CameraCollectionPaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * По умолчанию: CHANGED_AT
       */
      "orderByType": {
        "type": "CameraCollectionPaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\nПо умолчанию: CHANGED_AT",
      },
      /**
       * Тип направления сортировки.
       * По умолчанию: DESC
       */
      "directionType": {
        "type": "CameraCollectionPaging.DirectionType",
        "text": "Тип направления сортировки.\nПо умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * Диапазон: 0..100.
       * По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\nДиапазон: 0..100.\nПо умолчанию: 20",
      },
      /**
       * Сдвиг.
       * Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\nДиапазон: 0..2147483647",
      },
    },
  },
  /**
   * Запрос удаления коллекции камер
   */
  "DeleteCameraCollectionRequest": {
    "kind": "class",
    "text": "Запрос удаления коллекции камер",
    "fields": {
      /**
       * Идентификатор коллекции камер.
       * Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор коллекции камер.\nТип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления коллекции камер
   */
  "DeleteCameraCollectionResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления коллекции камер",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "DeleteCameraCollectionResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "DeleteCameraCollectionResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения количества коллекций камер
   */
  "GetCameraCollectionCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества коллекций камер",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "CameraCollectionFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества коллекций камер
   */
  "GetCameraCollectionCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества коллекций камер",
    "fields": {
      /**
       * Всего
       */
      "data": {
        "type": "int32",
        "text": "Всего",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetCameraCollectionCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "GetCameraCollectionCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения списка коллекций камер
   */
  "GetCameraCollectionListRequest": {
    "kind": "class",
    "text": "Запрос получения списка коллекций камер",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "CameraCollectionFilter",
        "text": "Фильтр",
      },
      /**
       * Постраничный вывод
       */
      "paging": {
        "type": "CameraCollectionPaging",
        "text": "Постраничный вывод",
      },
    },
  },
  /**
   * Ответ на запрос получения списка коллекций камер
   */
  "GetCameraCollectionListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка коллекций камер",
    "fields": {
      /**
       * Коллекция камер
       */
      "data": {
        "type": "CameraCollection",
        "text": "Коллекция камер",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetCameraCollectionListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "GetCameraCollectionListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения коллекции камер
   */
  "GetCameraCollectionRequest": {
    "kind": "class",
    "text": "Запрос получения коллекции камер",
    "fields": {
      /**
       * Идентификатор коллекции камер.
       * Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор коллекции камер.\nТип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения коллекции камер
   */
  "GetCameraCollectionResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения коллекции камер",
    "fields": {
      /**
       * Коллекция камер
       */
      "data": {
        "type": "CameraCollection",
        "text": "Коллекция камер",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetCameraCollectionResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "GetCameraCollectionResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос восстановления удаленной коллекции камер
   */
  "PostCameraCollectionRestoreRequest": {
    "kind": "class",
    "text": "Запрос восстановления удаленной коллекции камер",
    "fields": {
      /**
       * Идентификатор коллекции камер.
       * Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор коллекции камер.\nТип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос восстановления удаленной коллекции камер
   */
  "PostCameraCollectionRestoreResponse": {
    "kind": "class",
    "text": "Ответ на запрос восстановления удаленной коллекции камер",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PostCameraCollectionRestoreResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "PostCameraCollectionRestoreResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на создание коллекции камер
   */
  "SaveCameraCollectionRequest": {
    "kind": "class",
    "text": "Запрос на создание коллекции камер",
    "fields": {
      /**
       * Коллекция камер
       */
      "data": {
        "type": "CameraCollection",
        "text": "Коллекция камер",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на создание коллекции камер
   */
  "SaveCameraCollectionResponse": {
    "kind": "class",
    "text": "Ответ на запрос на создание коллекции камер",
    "fields": {
      /**
       * Коллекция камер
       */
      "data": {
        "type": "CameraCollection",
        "text": "Коллекция камер",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "SaveCameraCollectionResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса создания
   */
  "SaveCameraCollectionResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса создания",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка сохранения
       */
      "saving": {
        "type": "CameraCollection.SavingError",
        "text": "Ошибка сохранения",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   * Тип: byte
   */
  "CameraCollectionPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.\nТип: byte",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   * Тип: byte
   */
  "CameraCollectionPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.\nТип: byte",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "ID": {
        "i": 1,
        "text": "По идентификатору",
      },
      /**
       * По имени
       */
      "NAME": {
        "i": 2,
        "text": "По имени",
      },
      /**
       * По времени изменения
       */
      "CHANGED_AT": {
        "i": 3,
        "text": "По времени изменения",
      },
    },
  },
}